// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3uo4s","header":"ReportDetails_header__2jjU3","title":"ReportDetails_title__mOIm4","left":"ReportDetails_left__2c5rE"};